import type { SettingsSubviewHeaderProps } from './Settings.types';
import type { ReactElement } from 'react';

import { Flex, Heading, IconButton } from '@rango-dev/whale';
import { ChevronLeft } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './Settings.module.css';

const BACK_ICON_SIZE = 16;

export function SettingsSubviewHeader(props: SettingsSubviewHeaderProps): ReactElement {
  const { title, backButtonId, onBack, action } = props;
  const { t } = useTranslation();

  return (
    <Flex align="center" className={styles.subviewHeader}>
      <IconButton
        id={backButtonId}
        aria-label={t('Back')}
        variant="ghost"
        color="gray"
        radius="full"
        size="1"
        onClick={onBack}>
        <ChevronLeft size={BACK_ICON_SIZE} />
      </IconButton>
      <Heading as="h2" size="3" weight="bold" className={styles.heading}>
        {title}
      </Heading>
      {action && (
        <Flex ml="auto" align="center">
          {action}
        </Flex>
      )}
    </Flex>
  );
}
